import React from 'react'
import Login from '../SignIn'

const Signup = props => <Login {...{ ...props, doSignup: true }} />

export default Signup